import template from "./bEditSettlement.html";
import moment from "moment";

export function bEditSettlementDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bEditSettlementController,
    controllerAs: 'bEditSettlement',
    bindToController: true,
    scope: {
      userSettlement: "=",
      showModal: "=",
    },
  };

  return directive;
}

class bEditSettlementController {
  constructor(API, Clients, Notes, bModal, $translate, $scope, $interval, $filter, $rootScope) {
    'ngInject';

    this.Notes = Notes;
    this.bModal = bModal;
    this.API = API;
    this.Clients = Clients;
    this.$translate = $translate;
    this.$filter = $filter;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$rootScope.reloadAnnualSettle = false;

    this.$interval = $interval;
    this.expiresAt = "";
    this.annualObjects = [];
    this.employeeView = false;
    this.allData = "";

    this.data = "";
    this.userSettlement = "";

    this.shareHeaders = [
      {name: this.$translate.instant("OVERTIME.MODAL.DATE"), class: "table-short", sort: "year"},
      {
        name: this.$translate.instant("OVERTIME.MODAL.OVER_TIME_BALANCE"),
        class: "table-short",
        sort: "cumulatedOvertime"
      },
      {name: this.$translate.instant("OVERTIME.MODAL.ACCEPTED_TIME_BALANCE"), class: "table-short", sort: "validFrom"},
      {name: this.$translate.instant("OVERTIME.MODAL.WORKLOGS_ACCEPTED"), class: "table-short", sort: "validUntil"},
      {name: this.$translate.instant("OVERTIME.MODAL.USED_OVERTIMES"), class: "table-short"},
      {name: this.$translate.instant("OVERTIME.MODAL.COMMENT"), class: "table-short", sort: "comment"},
      {id: "actions", name: null, class: "table-actions"},
    ];
    this.state = "loading";
  }

  initEdit() {
    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {
      this.$interval.cancel(timeout);
    });

    this.state = "loading";

    this.Clients.editSettlementView(this.userSettlement.id).then(res => {

      this.allData = {
        ...res.data.settlementEditView,
        cumulatedOvertime : this.$filter("hmsa")(moment.duration(res.data.settlementEditView.cumulatedOvertime).toJSON())
      };
      const settles = res.data.settlementEditView.settles.map((x) => {
        return {
          ...x,
          settledOvertime: this.$filter("hmsa")(moment.duration(x.settledOvertimeBeforeEdit).toJSON())
        };
      }).sort((a, b) => new Date(b.acceptedOvertimeDate) - new Date(a.acceptedOvertimeDate));

      let settlesPreviousYears = {
        ...this.allData.settlesPreviousYears,
        workTime : "",
        worknorm : {
          worknorm: ""
        },
        overtimeAlreadyUsed: "",
        acceptedOvertime: "",
        acceptedOvertimeDate: "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS",
        settledOvertime: this.$filter("hmsa")(moment.duration(this.allData.settlePreviousYears.settledOvertimeBeforeEdit).toJSON())
      };

      settles.push(settlesPreviousYears);
      this.settlesObjects = settles.reverse();
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });

  }

  setupData(data) {
    this.userSettlement = data.userSettlement;
    this.init();
  }

  closeShareModal() {
    this.$rootScope.reloadAnnualSettle = true;
    this.showModal = false;
  }

  saveEditSettlement(){
    let settleFromPreviousYears = this.settlesObjects.filter(x =>{
      if(x.acceptedOvertimeDate === "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS"){
        return x;
      }
    })[0];

    let settles = this.settlesObjects.filter(x =>{
      if(x.acceptedOvertimeDate !== "OVERTIME.CUMULATED_FROM_PREVIOUS_YEARS"){
        x.settledOvertime = moment.duration(x.settledOvertime).toJSON();
        return x;
      }
    });

    const saveObject = {
      date: this.userSettlement.date,
      settles: settles,
      comment: this.userSettlement.comment,
      settleFromPreviousYears: moment.duration(settleFromPreviousYears.settledOvertime).toJSON()
    };

    this.Clients.saveEditSettlement(this.userSettlement.id, saveObject).then(() => {
      this.Notes.postNote({
        type: "success",
        message: this.$translate.instant("VIEW360.MODAL.SUCCESS_SAVED")
      });
    }, (res) => {

      this.modalConfig = {
        text: res.data.message,
        acceptText: this.$translate.instant("OK"),
        cancelText: "",
        hideLeftButton: "hide"
      };

      this.bModal.show(this.modalConfig).then(() => {
      }, (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      });
    }, angular.noop);

    setTimeout(this.init(), 300);

  }

  inputChange(settlesObject) {
    if (settlesObject.settledOvertime === '0') {
      settlesObject.settledOvertime = "00:00:00";
      settlesObject.durationInvalid = false;
    }
    else {
      let format = /^-?(\d+):(?:[012345]\d):(?:[012345]\d)/;
      let match = settlesObject.settledOvertime.match(format);

      if (match) { settlesObject.durationInvalid = false; }
      else { settlesObject.durationInvalid = true; }
    }
  }

  useFifo() {
    let all =  moment.duration(this.allData.cumulatedOvertime);
    this.settlesObjects.map( element => {
      let div = moment.duration(element.acceptedOvertime) - moment.duration(element.overtimeAlreadyUsed);
      if(div <= all)
      {
        element.settledOvertime = this.$filter("hmsa")(moment.duration(div).toJSON());
        all -= div;
      }
      else if( div > all && all > 0) {
        element.settledOvertime = this.$filter("hmsa")(moment.duration(all).toJSON());
        all = 0;
      }
    });
    this.allData.cumulatedOvertime = all;
  }

}
